import api from '../../plugins/api';

// Ð£Ð±Ð¸ÑÐ°ÐµÑ Ð¿ÑÐ¸ÑÐ»Ð°Ð½Ð½ÑÐ¹ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð¼ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ Ð²Ð¸Ð´Ð° kind (Ð²ÑÐµ ÐµÐ³Ð¾ Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸ Ð¿Ð¾ ÑÐ´ÐµÐ»ÐºÐµ).
const deleteClientUploadFile = ({ dealId, kind }) => {
  return api.post('/api/crm/clientUpload/deleteFile', { dealId, kind });
};

export default deleteClientUploadFile;
